<div class="addCard_modal">
  <p-button
    class="close_modal"
    (click)="closeDialog()"
    role="button"
    tabIndex="{0}"
    onKeyDown="{handleKeyDown}"
    icon="pi pi-times"
  ></p-button>
  <div class="modal_title">
    <h2>{{ title }}</h2>
  </div>
  <div class="form_grid gap_p">
    <div class="w_100">
      <input
        type="file"
        accept=".xlsx,.xls,.csv"
        (change)="onFileSelect($event)"
        hidden
        #fileInput
      />
      @if (!selectedFile()) {
      <div class="upload_file v2" (click)="fileInput.click()">
        <figure>
          <img [src]="assetsConst.uploadIcon" alt="icon" />
        </figure>
        <div class="upload_cnt hd_6">
          <h3>{{ subTitle }}</h3>
          <small [innerHTML]="description"></small>
        </div>
      </div>
      } @else {
      <div class="w_100">
        <div class="uploaded_file">
          <figure>
            <img [src]="assetsConst.UploadedIcon" alt="icon">
          </figure>
          <div class="uploaded_cnt hd_6">
            <h3 class="fw_500">{{ selectedFile()?.name }}</h3>
            <p>File size: {{ (selectedFile()?.size! / 1024 / 1024).toFixed(2) }} MB</p>
          </div>
          <p-button
            icon="pi pi-times"
            [link]="true"
            (click)="selectedFile.set(null); $event.stopPropagation()"
          />
        </div>
      </div>
      }
    </div>
  </div>
  <div class="btn_flex mt_20">
    <p-button
      label="Go Back"
      severity="contrast"
      variant="outlined"
      (click)="closeDialog()"
      role="button"
      tabIndex="{1}"
      onKeyDown="{handleKeyDown}"
      [disabled]="isUploading()"
    />

    <p-button
      label="{{ isUploading() ? 'Uploading...' : 'Submit' }}"
      (click)="submitBulkUpload()"
      role="button"
      tabIndex="{2}"
      onKeyDown="{handleKeyDown}"
      [disabled]="!selectedFile() || isUploading()"
      [loading]="isUploading()"
    ></p-button>
  </div>
</div>
